



















import { Component, Vue } from 'vue-property-decorator';
import { JobNotes } from '@/models/jobNotes/jobNotes';
import JobNotesDetail from '@/components/jobNotes/JobNotesDetail.vue';
import * as JobsAPI from '@/api/jobsApi';
import Nullable from '@/types/nullable';

@Component({
  components: {
    JobNotesDetail
  }
})
export default class ViewJobNotes extends Vue {
  private loading: boolean = false;
  private errorMessage: string = null;
  private noteArray: Nullable<[JobNotes]> = null;

  private jobNotes: Nullable<JobNotes> = null;
  private schedulerNotes: Nullable<JobNotes> = null;
  
  created() {
    this.init();
  }

  handleDataChanged(){
    this.init();
  }

  async init(){
    this.loading = true;

    try {
      this.noteArray = await JobsAPI.getNotes(this.$route.params.jobID);

      this.jobNotes = this.noteArray.find(x => x.job_note_type_id == 1);
      this.schedulerNotes = this.noteArray.find(x => x.job_note_type_id == 3);
    } catch (err){
      this.errorMessage = err;
    }

    this.loading = false;
  }
}

